module.exports = __webpack_public_path__ + "static/media/neo4j.bdbb3ec8.png";